/** API route map: URLS.Controller.ClientContactNotes */
export const ClientContactNotes = {
      Name: 'ClientContactNote/',
      GetAllNote: 'client-contact-note',
      AddNote: 'add-client-note',
      UpdateClientContactNote: 'update',
      DeleteClientContactNote: 'delete',
};
